/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     登录/登出 API 接口
  | @Version:   2018-11-27  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";
import pmRequest from "@/utils/pmRequest";
export function getLoginConfigApi (query) {
  return request({
    url: "?c=login&a=visit",
    method: "get"
  });
}

export function loginByMobileApi (formData) {
  return request({
    url: "?c=login&a=login",
    method: "post",
    data: formData
  });
}

export function loginSettingApi (formData) {
  return request({
    url: "?c=login&a=setting",
    method: "post",
    data: formData
  });
}

export function logoutApi () {
  return request({
    url: "?c=login&a=logout",
    method: "post"
  });
}

export function pmLoginApi (query) {
  return pmRequest({
    url: "/api/users/getToken",
    method: "get",
    data: query
  });
}

export function initLoginApi (params) {
  return request({
    url: "?c=login&a=qr&do=get",
    method: "get",
    params
  });
}

export function getQrApi (params) {
  return request({
    url: "?c=login&a=qr&do=get",
    method: "get",
    params
  });
}

export function checkLoginApi (params) {
  return request({
    url: "?c=login&a=qr&do=query",
    method: "get",
    params
  });
}
